var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e(),(_vm.currPage !== 'Login')?_c('div',{staticStyle:{"position":"absolute","top":"100px","left":"20px","z-index":"100"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }